// extracted by mini-css-extract-plugin
export default {"body":"Nav_body__FQtt8","item":"Nav_item__Y2DF7","item__text":"Nav_item__text__YMXkY","item--active":"Nav_item--active__zCy21"};